import React from 'react';

import { StyledTableHeader } from './styles';

export const TableHeader = props => <StyledTableHeader {...props} />;
